// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__u6upk","form__left":"form_form__left__hV8Gl","form__details":"form_form__details__Gi6I_","form__summary":"form_form__summary__WEQHs"};